import SearchPage from '@/views/covers/SearchPage'

export default function SearchScreen() {
  return <SearchPage />
}
